import { makeRequest } from '@/base/MaRequestPooler.js'

export function get() {
  return makeRequest('/slack-integration')
}

export function deleteSlackIntegration(ids) {
  return makeRequest('/slack-integration', {
    method: 'DELETE',
    data: ids,
  })
}

export function saveKey(key) {
  return makeRequest(`/slack-integration/authorization-key?key=${key}`, { method: 'POST' })
}

export function callback(urlParams) {
  const url = urlParams.startsWith('?') ? urlParams : (`?${urlParams}`)
  return makeRequest(`/slack-integration/oauth2/callback${url}`)
}
